import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BusinessRoleInput, BusinessRoleResult, GetBusinessRolesInput, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class BusinessRoleService {

  constructor(private httpClient: HttpClient) { }

  public addBusinessRole(businessRoleInput: BusinessRoleInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'BusinessRole/AddBusinessRole', businessRoleInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editBusinessRole(id: number, businessRoleInput: BusinessRoleInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'BusinessRole/EditBusinessRole?id=' + id, businessRoleInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteBusinessRole(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'BusinessRole/DeleteBusinessRole?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getBusinessRoles(getBusinessRolesInput: GetBusinessRolesInput, token: string): Promise<ResultList<BusinessRoleResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'BusinessRole/GetBusinessRoles', getBusinessRolesInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<BusinessRoleResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<BusinessRoleResult>(), result.error));
  }
}
